import { useQuery } from "@tanstack/react-query";
import { MitreAPI } from "../mitre.api";
import { SelectBox } from "@monolith-forensics/monolith-ui";
import { useUncontrolled } from "@mantine/hooks";

export interface TacticsSelectBoxProps {
  defaultValue?: string;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  colSpan?: number;
}

export const TacticsSelectBox: React.FC<TacticsSelectBoxProps> = ({
  defaultValue,
  value,
  error,
  onChange,
}) => {
  const [_value, handleChange] = useUncontrolled({
    value,
    defaultValue,
    onChange,
  });

  const { data: tactics, isLoading } = useQuery({
    queryKey: ["mitre", "tactics", "list"],
    queryFn: () => MitreAPI.getTactics(),
    select: (data) =>
      (data?.data || []).map((tactic) => ({
        label: tactic.name,
        value: tactic.uuid,
        data: tactic,
      })),
  });

  return (
    <SelectBox
      data={tactics}
      defaultValue={defaultValue}
      value={value}
      label="MITRE Tactic"
      placeholder="Select a tactic"
      onChange={onChange}
      loading={isLoading}
      error={error}
    />
  );
};
